const RECORDVIEW_DESKTOP = {
  config: {
    layout: {
      column_default_actions: {},
      columns: [],
      multi_select_custom_actions: [],
      multi_select_default_actions: {},
      onscreen_filters: [],
      catalog: {
        elements: [],
        embedded_detailview: {
          detailview_id: ""
        }
      },
      prefilters_joined_by: "",
      default_catalog_view: false,
      default_sort: [],
      page_size: [5, 10, 25, 50],
      pre_filters: [],
      tiles: [],
      charts: [],
      owner_pre_filters: {
        logged_user: false,
        next_activities: [],
        hide_activities: false
      },
      allow_download: false,
      search: true,
      manage_column: true,
      hide_header: false,
      hide_footer: false,
      data_limit: 50,
      layout_type: "table_view",
      title: "",
      table_id: "" // need update
    }
  },
  device: "desktop",
  description: "",
  // block_tag: "",
  name: "", //need update
  table_type: "" //need update
};
const PIVOT_CHART = {
  config: {
    layout: {
      column_default_actions: {},
      columns: [],
      multi_select_custom_actions: [],
      multi_select_default_actions: {},
      onscreen_filters: [],
      catalog: {
        elements: [],
        embedded_detailview: {
          detailview_id: ""
        }
      },
      prefilters_joined_by: "",
      default_catalog_view: false,
      default_sort: [],
      page_size: [5, 10, 25, 50],
      pre_filters: [],
      tiles: [],
      owner_pre_filters: {
        logged_user: false,
        next_activities: [],
        hide_activities: false
      },
      pivot_charts: [],
      allow_download: false,
      search: true,
      manage_column: true,
      data_limit: 50,
      layout_type: "table_view",
      title: "",
      table_id: "" // need update
    }
  },
  device: "desktop",
  description: "",
  name: "", //need update
  table_type: "" //need update
};

const RECORDVIEW_MOBILE = {
  config: {
    layout: {
      header: {
        column1: {
          width: 50,
          elements: []
        },
        column2: {
          width: 50,
          elements: []
        }
      },
      footer: {
        column1: {
          width: 50,
          elements: []
        },
        column2: {
          width: 50,
          elements: []
        }
      },
      multi_select_custom_actions: [],
      multi_select_default_actions: {},
      onscreen_filters: [],
      prefilters_joined_by: "",
      default_sort: [],
      pre_filters: [],
      catalog: {},
      tiles: [],
      owner_pre_filters: {
        logged_user: false,
        next_activities: [],
        hide_activities: false
      },
      data_limit: 50,
      on_row_action: {},
      popup_position: "center",
      search: true,
      manage_column: true,
      hide_header: false,
      style: {},
      table_id: "",
      title: ""
    }
  },
  device: "mobile",
  description: "",
  // block_tag: "",
  name: "",
  table_type: "" //need update
};

const DETAILVIEW = {
  name: "",
  device: "desktop",
  table_type: "",
  description: "",
  // block_tag: "",
  data: {
    table_id: "",
    elements: [],
    data_fields: []
  },
  access_templates: [],
  detailview_settings: {
    show_print: false,
    size: ""
  }
};

const CHART = {
  name: "",
  device: "",
  description: "",
  // block_tag: "",
  table_type: "",
  config: {
    global_filters: {
      fields: [],
      pre_filters: [],
      prefilters_joined_by: "",
      owner_pre_filters: {
        logged_user: false,
        next_activities: [],
        hide_activities: false
      }
    },
    charts: [],
    tiles: [],
    table_id: ""
  }
};

const PROGRESS_BAR = {
  name: "",
  device: "",
  description: "",
  config: {
    data: {
      progress_type: "",
      global_field_id: ""
    },
    table_id: ""
  }
};

const QUERYBLOCK = {
  name: "",
  table_type: "",
  description: "",
  info_tag: [],
  config: {
    blocks: []
  },
  device: "desktop",
  access_templates: []
};
const appBlockConfig = {
  recordview_desktop: RECORDVIEW_DESKTOP,
  recordview_mobile: RECORDVIEW_MOBILE,
  detailsview: DETAILVIEW,
  chart: CHART,
  "progress-bar": PROGRESS_BAR,
  pivotcharts: PIVOT_CHART,
  queryblocks: QUERYBLOCK
};

export { appBlockConfig };
